"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagingHelper = void 0;
var lodash_1 = __importDefault(require("lodash"));
var PagingHelper = /** @class */ (function () {
    function PagingHelper() {
    }
    PagingHelper.prototype.page = function (items, pageRange) {
        return (0, lodash_1.default)(items).drop(pageRange.offset).take(pageRange.limit).value();
    };
    return PagingHelper;
}());
exports.PagingHelper = PagingHelper;
exports.default = PagingHelper;
